import(/* webpackMode: "eager", webpackExports: ["TermsAndConditionsView"] */ "D:\\FekerTech\\Shahen Website New\\src\\sections\\terms-and-conditions\\view\\terms-and-conditions-view.jsx");
